/* eslint-disable no-unused-vars */
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "./ToastNotification.css";

const toastNotification = (props) => {
  const toast = {
    Command: toastr[`${props.type}`](
      props.mannualDismissal
        ? `${
            props.message +
            '<br /><button type="button" class="btn clear" style="float: right;">Ok</button>'
          }`
        : `${props.message}`,
      `${props.title}`,
      {
        closeButton: false,
        debug: false,
        newestOnTop: false,
        progressBar: false,
        positionClass: props.mannualDismissal
          ? "toast-top-full-width"
          : "toast-top-center",
        maxOpened: 1,
        autoDismiss: true,
        preventDuplicates: true,
        onclick: null,
        showDuration: "800",
        hideDuration: "1000",
        timeOut: props.mannualDismissal ? 0 : "3000",
        extendedTimeOut: props.mannualDismissal ? 0 : "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
      }
    ),
  }.toString();

  return null;
};

export default toastNotification;
